/**
 * Merge all meta from route
 * Keep last child key is case of conflict on a keys
 *
 * @param {Route} route Route from vue-router
 */
export function getRouteMeta (route) {
  return Object.assign({}, ...route.matched.map(item => item.meta))
}
